import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`;

export const Name = styled.h1`
  margin: 0;
  min-width: 0;
  overflow-wrap: anywhere;
  font-size: 24px;
  font-weight: 700;
  color: ${colors.textPrimary};
`;

export const TariffSummary = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
  font-size: 14px;
  color: ${colors.textSecondary};
`;

export const TabContent = styled.div`
  margin-top: 20px;
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: min(420px, 100%);
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const TableActions = styled(Actions)`
  margin-top: 16px;
`;

export const RowActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 4px;
`;

export const StatusBadge = styled.span<{ $tone: "success" | "warning" | "danger" }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background: ${({ $tone }) =>
    $tone === "success" ? colors.success : $tone === "warning" ? colors.amber : colors.danger};
`;

export const ReceiptLink = styled.a`
  color: ${colors.primary};
  font-size: 13px;
`;

export const Documents = styled.div`
  display: flex;
  gap: 10px;
`;

export const ActButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-size: 13px;
  color: ${colors.primary};
  text-decoration: underline;
  cursor: pointer;

  &:disabled {
    color: ${colors.textSecondary};
    cursor: default;
  }
`;

// Кнопки счёта — в столбик: рядом они занимали треть строки, а на узком экране распирали её.
export const InvoiceActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  width: 100%;
`;

export const StatusStripe = styled.div<{ $tone: "success" | "warning" | "danger" }>`
  width: 4px;
  height: 28px;
  border-radius: 2px;
  background: ${({ $tone }) =>
    $tone === "success" ? colors.success : $tone === "warning" ? colors.amber : colors.danger};
`;

export const TariffCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const MutedLine = styled.div`
  font-size: 12px;
  color: ${colors.textSecondary};
`;
